// src/redux/thunks/fetchAppointmentsByPatient.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
export const fetchAppointmentsByPatient = createAsyncThunk(
  'appointments/fetchByPatient',
  async (userId, { rejectWithValue }) => {
    try {
     
      
      const { data } = await axios.get(`${baseUrl}/appointments/patient/${userId}`);
      const appointments = data?.appointments || [];

      // Optional filtering (in case API isn't strict)
      const filtered = appointments.filter(appt => appt?.patientInfo?.id === userId);
     

      return filtered;
    } catch (err) {
      console.error("❌ Error fetching appointments:", err?.response || err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to fetch appointments');
    }
  }
);
